export const APP_CATEGORY_APPOINTMENT_SCHEDULING = 'Appointment scheduling',
  APP_CATEGORY_PATIENT_ACQUISITION_AND_ENGAGEMENT =
    'Patient Acquisition and Engagement',
  APP_CATEGORY_VOICE_RECOGNITION = 'Voice Recognition',
  APP_CATEGORY_VALUE_BASED_REIMBURSEMENT_SUPPORT =
    'Value-Based Reimbursement Support',
  APP_CATEGORY_TELEHEALTH = 'Telehealth',
  APP_CATEGORY_SPECIALTY_SOLUTIONS = 'Specialty Solutions',
  APP_CATEGORY_PRECISION_MEDICINE = 'Precision Medicine',
  APP_CATEGORY_PATIENT_EDUCATION = 'Patient Education',
  APP_CATEGORY_MEDICATION_AND_PRESCRIPTIONS = 'Medication/Prescriptions',
  APP_CATEGORY_BILLING_OPTIMIZATION = 'Billing Optimization',
  APP_CATEGORY_INVENTORY_MANAGEMENT = 'Inventory Management',
  APP_CATEGORY_IMAGING_AND_DOCUMENT_MANAGEMENT =
    'Imaging and Document Management',
  APP_CATEGORY_COMPLIANCE_AND_SECURITY = 'Compliance and Security',
  APP_CATEGORY_CLINICAL_DECISION__SUPPORT = 'Clinical Decision Support',
  APP_CATEGORY_CHECKIN_SOLUTIONS = 'Check-in Solutions',
  APP_CATEGORY_CARE_MANAGEMENT = 'Care Management',
  APP_CATEGORY_WORKFLOW_EFFICIENCY = 'Workflow Efficiency';
